























































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
import TipoEvaluacion from '@/models/evaluacion/tipoEvaluacion.model';
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue"
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import Pregunta from '../../../models/evaluacion/pregunta.model';
import { AnswerType } from '@/enums/AsnwerType';
@Component({
  components: {
    UserBasicInformationComponent, ResearchCenterBasicInformationComponent
  }
})
export default class EvaluationTypeTable extends GenericBTable<Pregunta> {
  isLoading = false;
  
  textBox: AnswerType = AnswerType.TEXTBOX;
  checkBox: AnswerType = AnswerType.CHECKBOX;
  select: AnswerType = AnswerType.SELECT;

  created() {
    this.permissionValue = PermissionValue.TIPOEVALUACION;
    let id = Number(this.$route.params.id);
    this.tableConfig.controller = 'Pregunta';
    this.tableConfig.whereParams = `tipoEvaluacionId eq ${id}`; 
    this.tableConfig.enableDefaultColumns = false;
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
   
    //let titulo = new BTableColumn("titulo", "table.title", true);
    let texto = new BTableColumn("texto", "table.texto", true);
    let orden = new BTableColumn("orden", "table.orden", true);
    let preguntaOpcionRespuesta = new BTableColumn("preguntaOpcionRespuestas", "table.preguntaOpcionRespuestas", true);
    
    //titulo.customTemplate = true;
    preguntaOpcionRespuesta.customTemplate = true;

    this.tableConfig.insertColumns(orden, texto, preguntaOpcionRespuesta);

    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
 
}
